<template lang="pug">
.sticker.restaurant(v-if="restaurant")
  .bg(:style="{ 'background-image': `url('img/restaurants/${ restaurant }/logo.png')` }")
  .bg(:style="{ 'background-image': `url('img/restaurants/${ restaurant }/logo.png')` }")
  .bg(:style="{ 'background-image': `url('img/restaurants/${ restaurant }/logo.png')` }")
.sticker(v-else)
  qr.code.small(:value="href || `https://876menu.com/${ plate }`",
                :title="href || `https://876menu.com/${ plate }`",
                render-as="svg",
                background="#301e0b",
                foreground="white")
  .box.top.left
  .box.top
  .box.bottom.left
  .box.bottom
  .plate {{ license }}
  .logo-876
    .bg(:style="{ 'background-image': `url('/img/876menu.png')` }")
    .bar
    .box
    .circle
</template>
<script>
import QrcodeVue from 'qrcode.vue';
import { mapGetters } from 'vuex';
export default {
  name: 'sticker',
  props: {
    plate: String,
    href: String,
    restaurant: String
  },
  computed: {
    ...mapGetters(['order']),
    license() {
      const { plate, order } = this;
      return plate || order?.meta?.lp || '';
    }
  },
  components: { qr: QrcodeVue }
};
</script>
<style scoped lang="scss">
.sticker {
  position: relative;
  width: 18rem;
  height: 6.5rem;
  &.modal {
    //transform: scale(2);
    //transform-origin: bottom center;
    & > .box {
      background-position-y: -4.4rem;
      background-size: 27%;
      &.bottom {
        background-position-y: -3.8rem;
      }
      &.left {
        background-size: 190%;
        background-position-x: -1rem;
      }
    }
  }
  &.restaurant {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-content: flex-end;
    position: relative;
    left: 3.5rem;
    .bg {
      height: 100%;
      background: no-repeat center;
      background-size: contain;
    }
  }
  & > .plate {
    position: absolute;
    top: 0;
    left: 0;
    transform: translate3d(-69%, 270%, 0) rotate(-90deg);
    box-sizing: border-box;
    width: 3.75rem;
    padding: 0.125rem 0.25rem;
    background-color: white;
    z-index: 5;
    font-size: 0.9rem;
    border-radius: 0.125rem;
    white-space: nowrap;
    font-family: Assistant, sans-serif;
  }
  & > .box {
    position: absolute;
    left: 0;
    width: 13.5rem;
    padding-top: 16.3%;
    z-index: 4;
    background-position-x: 6px;
    background-position-y: -2.1rem;
    transform: translate3d(47%, 0, 0);
    //transform: translate3d(67%, 0, 0);
    //background-color: #2b1a06;
    background-image: url("data:image/svg+xml;charset%3Dutf8,%3Csvg width%3D'100' height%3D'100' shape-rendering%3D'crispEdges' xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'0 0 33 33' data-v-0c38604d%3D''%3E%3Cpath fill%3D'%23301e0b' d%3D'M0,0 h33v33H0z'%3E%3C/path%3E%3Cpath fill%3D'white' d%3D'M0 0h7v1H0zM10 0h1v1H10zM13 0h2v1H13zM21 0h1v1H21zM23 0h2v1H23zM26,0 h7v1H26zM0 1h1v1H0zM6 1h1v1H6zM9 1h1v1H9zM12 1h2v1H12zM15 1h2v1H15zM19 1h2v1H19zM22 1h2v1H22zM26 1h1v1H26zM32,1 h1v1H32zM0 2h1v1H0zM2 2h3v1H2zM6 2h1v1H6zM11 2h1v1H11zM13 2h2v1H13zM17 2h1v1H17zM19 2h1v1H19zM23 2h1v1H23zM26 2h1v1H26zM28 2h3v1H28zM32,2 h1v1H32zM0 3h1v1H0zM2 3h3v1H2zM6 3h1v1H6zM13 3h2v1H13zM16 3h3v1H16zM20 3h1v1H20zM23 3h2v1H23zM26 3h1v1H26zM28 3h3v1H28zM32,3 h1v1H32zM0 4h1v1H0zM2 4h3v1H2zM6 4h1v1H6zM8 4h1v1H8zM10 4h1v1H10zM12 4h1v1H12zM15 4h1v1H15zM17 4h1v1H17zM20 4h2v1H20zM23 4h2v1H23zM26 4h1v1H26zM28 4h3v1H28zM32,4 h1v1H32zM0 5h1v1H0zM6 5h1v1H6zM9 5h1v1H9zM11 5h1v1H11zM13 5h1v1H13zM15 5h3v1H15zM23 5h1v1H23zM26 5h1v1H26zM32,5 h1v1H32zM0 6h7v1H0zM8 6h1v1H8zM10 6h1v1H10zM12 6h1v1H12zM14 6h1v1H14zM16 6h1v1H16zM18 6h1v1H18zM20 6h1v1H20zM22 6h1v1H22zM24 6h1v1H24zM26,6 h7v1H26zM8 7h2v1H8zM11 7h1v1H11zM13 7h2v1H13zM17 7h1v1H17zM19 7h2v1H19zM22 7h1v1H22zM24 7h1v1H24zM2 8h2v1H2zM6 8h4v1H6zM15 8h3v1H15zM19 8h1v1H19zM21 8h3v1H21zM25 8h2v1H25zM28 8h1v1H28zM1 9h2v1H1zM5 9h1v1H5zM12 9h1v1H12zM14 9h1v1H14zM16 9h4v1H16zM21 9h6v1H21zM29 9h1v1H29zM31,9 h2v1H31zM1 10h1v1H1zM4 10h1v1H4zM6 10h1v1H6zM8 10h1v1H8zM10 10h2v1H10zM13 10h4v1H13zM19 10h1v1H19zM23 10h3v1H23zM30 10h1v1H30zM32,10 h1v1H32zM0 11h4v1H0zM7 11h1v1H7zM10 11h2v1H10zM13 11h1v1H13zM15 11h5v1H15zM23 11h1v1H23zM27 11h3v1H27zM31 11h1v1H31zM0 12h1v1H0zM2 12h3v1H2zM6 12h3v1H6zM10 12h1v1H10zM18 12h2v1H18zM21 12h1v1H21zM25 12h1v1H25zM32,12 h1v1H32zM5 13h1v1H5zM7 13h1v1H7zM9 13h2v1H9zM14 13h5v1H14zM21 13h2v1H21zM24 13h1v1H24zM29 13h1v1H29zM0 14h1v1H0zM3 14h2v1H3zM6 14h9v1H6zM20 14h2v1H20zM25 14h1v1H25zM27 14h4v1H27zM1 15h1v1H1zM4 15h1v1H4zM10 15h1v1H10zM12 15h1v1H12zM14 15h1v1H14zM17 15h2v1H17zM21 15h3v1H21zM25 15h1v1H25zM27 15h1v1H27zM30,15 h3v1H30zM1 16h1v1H1zM6 16h2v1H6zM10 16h1v1H10zM18 16h1v1H18zM21 16h1v1H21zM24 16h3v1H24zM29 16h1v1H29zM0 17h1v1H0zM2 17h1v1H2zM5 17h1v1H5zM8 17h4v1H8zM13 17h2v1H13zM16 17h1v1H16zM19 17h5v1H19zM25 17h1v1H25zM27 17h2v1H27zM30 17h1v1H30zM32,17 h1v1H32zM2 18h1v1H2zM5 18h7v1H5zM15 18h2v1H15zM18 18h3v1H18zM22 18h1v1H22zM25 18h2v1H25zM28 18h1v1H28zM30 18h1v1H30zM1 19h2v1H1zM4 19h2v1H4zM9 19h1v1H9zM11 19h1v1H11zM13 19h1v1H13zM16 19h3v1H16zM20 19h1v1H20zM27 19h2v1H27zM0 20h1v1H0zM2 20h7v1H2zM10 20h1v1H10zM12 20h2v1H12zM16 20h2v1H16zM21 20h1v1H21zM24 20h1v1H24zM26 20h1v1H26zM29 20h3v1H29zM0 21h3v1H0zM4 21h1v1H4zM7 21h1v1H7zM11 21h1v1H11zM13 21h5v1H13zM19 21h3v1H19zM24 21h1v1H24zM29 21h2v1H29zM32,21 h1v1H32zM5 22h2v1H5zM8 22h1v1H8zM14 22h1v1H14zM17 22h2v1H17zM20 22h1v1H20zM23 22h2v1H23zM26 22h1v1H26zM28 22h1v1H28zM30,22 h3v1H30zM1 23h5v1H1zM7 23h1v1H7zM10 23h2v1H10zM13 23h4v1H13zM18 23h2v1H18zM25 23h1v1H25zM27 23h2v1H27zM32,23 h1v1H32zM0 24h1v1H0zM2 24h1v1H2zM4 24h1v1H4zM6 24h1v1H6zM11 24h3v1H11zM18 24h3v1H18zM24 24h6v1H24zM8 25h2v1H8zM11 25h5v1H11zM17 25h2v1H17zM21 25h4v1H21zM28 25h1v1H28zM30 25h2v1H30zM0 26h7v1H0zM8 26h1v1H8zM10 26h1v1H10zM14 26h1v1H14zM16 26h2v1H16zM19 26h3v1H19zM24 26h1v1H24zM26 26h1v1H26zM28 26h2v1H28zM31 26h1v1H31zM0 27h1v1H0zM6 27h1v1H6zM9 27h5v1H9zM15 27h1v1H15zM17 27h1v1H17zM19 27h1v1H19zM23 27h2v1H23zM28 27h1v1H28zM30,27 h3v1H30zM0 28h1v1H0zM2 28h3v1H2zM6 28h1v1H6zM9 28h4v1H9zM14 28h1v1H14zM16 28h3v1H16zM22 28h10v1H22zM0 29h1v1H0zM2 29h3v1H2zM6 29h1v1H6zM8 29h6v1H8zM15 29h2v1H15zM19 29h1v1H19zM21 29h2v1H21zM24 29h1v1H24zM27 29h1v1H27zM29 29h2v1H29zM0 30h1v1H0zM2 30h3v1H2zM6 30h1v1H6zM8 30h1v1H8zM12 30h2v1H12zM15 30h2v1H15zM20 30h1v1H20zM22 30h1v1H22zM24 30h3v1H24zM0 31h1v1H0zM6 31h1v1H6zM9 31h1v1H9zM14 31h2v1H14zM19 31h1v1H19zM22 31h5v1H22zM30 31h1v1H30zM32,31 h1v1H32zM0 32h7v1H0zM10 32h1v1H10zM13 32h2v1H13zM18 32h1v1H18zM20 32h2v1H20zM23 32h1v1H23zM27 32h2v1H27z'%3E%3C/path%3E%3C/svg%3E");
    background-size: 47%;
    --radius: 1.5rem;
    &.left {
      width: 2rem;
      padding-top: 20%;
      transform: translate3d(-100%, 0, 0);
      background-position-x: 3.6rem;
      background-size: 252%;
      &.top {
        top: 0;
        border-top-left-radius: var(--radius);
      }
      &.bottom {
        bottom: 0.25rem;
        border-bottom-left-radius: var(--radius);
      }
    }
    &:not(.left) {
      &.top {
        top: 0;
        border-top-right-radius: var(--radius);
      }
      &.bottom {
        bottom: 0.25rem;
        border-bottom-right-radius: var(--radius);
      }
    }
  }
  .logo-876 {
    position: absolute;
    top: 23%;
    left: 0;
    transform: translate3d(-4%, 0, 0);
    width: 100%;
    padding-top: 15.5%;
    pointer-events: none;
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
    z-index: 1000;
    transform: scale(1.2);
    .bg {
      background: no-repeat center right;
      background-size: contain;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 22;
    }
    .box {
      position: absolute;
      top: 21%;
      bottom: 18%;
      left: 38.1%;
      right: -2.5rem;
      background-color: white;
      z-index: 21;
    }
    .bar {
      position: absolute;
      top: 2%;
      bottom: -3%;
      left: 53%;
      width: 0.6rem;
      background-color: white;
      border-radius: 0.25rem;
    }
    .circle {
      position: absolute;
      top: 7%;
      left: 37.1%;
      width: 15%;
      padding-top: 14%;
      background-color: white;
      border-radius: 50%;
    }
  }
}
</style>
